<div class="transcript">
  @for (slot of transcript; track $index) {
    @if (slot.type === 'pause') {
      <div class="pause-indicator">
        <hr />
        {{ 'CALLS.PAUSED_FOR_DURATION' | translate: { duration: slot.actualDuration | duration: false : false } }}
        <hr />
      </div>
    } @else {
      <div class="slot-container">
        @if (slot.speaker | speaker: effectiveSpeakerMapping; as speakerLabel) {
          <div class="speaker clickable" (click)="selectSentence.emit(slot.sentences[0])">
            <app-avatar [input]="speakerLabel" size="small" [matTooltip]="speakerLabel"></app-avatar>
            {{ speakerLabel }}
            <span class="time">({{ slot.startTime | timestamp }})</span>
          </div>
        }
        @for (sentence of slot.sentences; track sentence.sentenceId) {
          <div
            class="sentence clickable"
            [class.highlight]="isHighlighted[sentence.sentenceId]"
            [style.scroll-margin-top.px]="25"
            [id]="'sentence-' + sentence.sentenceId"
            [attr.data-sentence-id]="sentence.sentenceId"
            (mouseup)="handleClickEvent(sentence)"
          >
            <span class="content"
              >{{ isSensitiveModeEnabled ? maskSentenceContent(sentence.content) : sentence.content }}
              @if (isPowerUserModeEnabled) {
                <span class="time power-user-mode">({{ sentence.startTimeSeconds | timestamp }} - {{ sentence.endTimeSeconds | timestamp }})</span>
              }
            </span>
            <div class="menu-positioner">
              <div style="visibility: hidden" [matMenuTriggerFor]="menu" #menuTrigger="matMenuTrigger" [attr.data-sentence-id]="sentence.sentenceId"></div>
            </div>
            <mat-menu #menu="matMenu">
              <ng-template matMenuContent>
                <button mat-menu-item (click)="copyRich()">
                  <mat-icon>content_copy</mat-icon>
                  <span translate="COMMON.COPY"></span>
                </button>
                @if (canEdit) {
                  <button mat-menu-item [matMenuTriggerFor]="speakerMenu" color="accent" translate="CALLS.ASSIGN_TO_SPEAKER"></button>
                }
                <mat-menu #speakerMenu="matMenu">
                  <ng-template matMenuContent>
                    @if (uniqueSpeakers.length > 0) {
                      <button mat-menu-item [matMenuTriggerFor]="existingSpeakersMenu" translate="CALLS.EXISTING_SPEAKERS"></button>
                    }
                    @if (filteredAttendeeNames.length > 0) {
                      <button mat-menu-item [matMenuTriggerFor]="attendeesMenu" translate="CALLS.FROM_ATTENDEES"></button>
                    }
                    <button mat-menu-item (click)="addSpeaker()">
                      <mat-icon>add</mat-icon>
                      <span translate="CALLS.NEW_SPEAKER"></span>
                    </button>
                  </ng-template>
                </mat-menu>
                <mat-menu #existingSpeakersMenu="matMenu">
                  <ng-template matMenuContent>
                    <div class="speaker-menu-content">
                      @for (speaker of uniqueSpeakers; track speaker.speakerTag) {
                        <button mat-menu-item (click)="updateSpeaker(speaker.speakerTag)">
                          {{ getSpeakerDropdownLabel(speaker) }}
                        </button>
                      }
                    </div>
                  </ng-template>
                </mat-menu>
                <mat-menu #attendeesMenu="matMenu">
                  <ng-template matMenuContent>
                    <div class="speaker-menu-content">
                      @for (attendeeName of filteredAttendeeNames; track attendeeName) {
                        <button mat-menu-item (click)="assignToAttendee(attendeeName)">
                          {{ attendeeName }}
                        </button>
                      }
                    </div>
                  </ng-template>
                </mat-menu>
              </ng-template>
            </mat-menu>
          </div>
        }
      </div>
    }
  }
</div>
